export default __webpack_public_path__ + "static/media/arrows.3a8c5c0b.webp";